// extracted by mini-css-extract-plugin
export default {"form":"QuestionAnswerSlideV8_form-a6s","text":"QuestionAnswerSlideV8_text-Ue5","question":"QuestionAnswerSlideV8_question-l8E","hint":"QuestionAnswerSlideV8_hint-a3Y"};